import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { Organization } from "@App/types";

type ContactPartnerProps = {
  organization?: Organization;
  showTitle?: boolean;
  partnerLogo: {
    url: string;
    alt: string;
  };
};

export const ContactPartner: FunctionComponent<ContactPartnerProps> = ({
  organization,
  showTitle = true,
  partnerLogo,
}: ContactPartnerProps) => {
  const { t } = useTranslation();
  if (!organization) return null;

  return (
    <div>
      {showTitle && (
        <div className="text-2xl font-serif text-neutral-700 mb-3">{t("contact.title")}</div>
      )}
      <p>{t("contact.partner.description", { organization: organization.name })}</p>
      <div className="flex gap-2 mt-3">
        <img
          className="max-w-[70px] max-h-[70px] md:max-w-[96px] md:max-h-[96px]"
          src={partnerLogo.url}
          alt={partnerLogo.alt}
        />
        <table>
          <tbody className="align-center">
            <tr>
              <td className="w-[60px] text-sm md:text-base leading-6">
                {t("contact.phone.label")}
              </td>
              <td>
                <a className="text-neutral-700 no-underline" href="tel:00496922220332332">
                  +49 69 2222 0332 332
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};
